import { OrderCreateRequest, OrderExchangeData, OrderType, ValidatedOrder } from '../../types';
import { formatDateToRequestDay, isDefined, Loadable } from '../../utils';
import { marketOrderTypes, orderTypesWhenPriceRequired, orderTypesWhenStopActivationPriceRequired } from './orderConst';

export const mapValidatedOrderToOrderRequest = (
  order: ValidatedOrder,
  exchange: OrderExchangeData | undefined,
): OrderCreateRequest => {
  return {
    isin: order.instrument.isin,
    quantity: order.quantity,
    stopActivationPrice: order.stopActivationPrice,
    expiryType: order.expiryType!,
    expiry: isDefined(order.expiry) ? formatDateToRequestDay(order.expiry) : undefined,
    direction: order.tradeType,
    orderType: order.orderType,
    tradingSession: order.tradingSession!,
    mic: order.instrument.mic,
    price: order.price,
    inventoryManagementMethod: order.inventoryManagementMethod,
    checkAutoConfirm: false,
    // Currently we are not stopping the order process if the exchange
    // data is not ready, we are just skipping the exchange part.
    ...(exchange && Loadable.hasValue(exchange.orderFields)
      ? { hasCurrencyExchange: true, ...exchange.orderFields }
      : { hasCurrencyExchange: false }),
  };
};

export const isMarketOrderType = (orderType: OrderType | undefined) => {
  if (!isDefined(orderType)) {
    return false;
  }

  return marketOrderTypes.includes(orderType);
};

export const isLimitOrderType = (orderType: OrderType | undefined) => {
  if (!isDefined(orderType)) {
    return false;
  }

  return orderTypesWhenPriceRequired.includes(orderType);
};

export const isStopActivationOrderType = (orderType: OrderType | undefined) => {
  if (!isDefined(orderType)) {
    return false;
  }

  return orderTypesWhenStopActivationPriceRequired.includes(orderType);
};
